import { useReducedMotion } from '@/lib/motion-utils'

/**
 * Hook that provides motion values respecting user's accessibility preferences
 * Returns appropriate animation configurations based on prefers-reduced-motion
 */
export function useAccessibleMotion() {
  const prefersReducedMotion = useReducedMotion()

  return {
    prefersReducedMotion,
    
    // Animation configurations that respect accessibility
    fadeIn: prefersReducedMotion
      ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.01 } }
      : { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 } },
    
    slideUp: prefersReducedMotion
      ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.01 } }
      : { initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.5 } },
    
    scaleIn: prefersReducedMotion
      ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.01 } }
      : { initial: { opacity: 0, scale: 0.95 }, animate: { opacity: 1, scale: 1 }, transition: { duration: 0.4 } },
    
    // Hover effects that respect reduced motion
    hoverLift: prefersReducedMotion
      ? {}
      : { whileHover: { y: -2, scale: 1.02 }, transition: { duration: 0.2 } },
    
    hoverScale: prefersReducedMotion
      ? {}
      : { whileHover: { scale: 1.05 }, whileTap: { scale: 0.98 }, transition: { duration: 0.2 } },
    
    // Stagger animations
    staggerChildren: prefersReducedMotion
      ? { transition: { staggerChildren: 0 } }
      : { transition: { staggerChildren: 0.1 } },
    
    // CSS class for conditional styling
    motionClassName: prefersReducedMotion ? 'motion-reduce' : '',
  }
}